import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { matieresApi } from '../api/matieres.api'
import type { CreateMatiereRequest, UpdateMatiereRequest } from '@/shared/types/admin'

const MATIERES_KEY = ['matieres']

export function useMatieres() {
  return useQuery({
    queryKey: MATIERES_KEY,
    queryFn: matieresApi.getAll,
    select: (data) => [...data].sort((a, b) => a.nom.localeCompare(b.nom)),
  })
}

export function useMatiere(id: number | undefined) {
  return useQuery({
    queryKey: [...MATIERES_KEY, id],
    queryFn: () => matieresApi.getById(id!),
    enabled: !!id,
  })
}

export function useCreateMatiere() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateMatiereRequest) => matieresApi.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MATIERES_KEY }),
  })
}

export function useUpdateMatiere() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateMatiereRequest }) =>
      matieresApi.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MATIERES_KEY }),
  })
}

export function useDeleteMatiere() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => matieresApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MATIERES_KEY }),
  })
}
